// MBO Niveau 4 Studies
// Professional vocational studies with comprehensive categories and specializations

export const MBO_NIVEAU_4_STUDIES = {
  'Gezondheidszorg en Welzijn': {
    'Zorg & Begeleiding': [
      'Mbo-Verpleegkundige',
      'Verzorgende IG (Individuele Gezondheidszorg)',
      'Persoonlijk begeleider maatschappelijke zorg',
      'Sociaal Pedagogisch Hulpverlener (SPH)',
      'Jeugdzorgwerker',
      'Leefstijlcoach',
      'Voeding- en leefstijladviseur',
      'Medisch Secretaresse',
      'Manager Gezondheidszorg',
      'Persoonlijk werkbegeleider zorgboerderij'
    ],
    'Assistenten & Paramedici': [
      'Doktersassistent',
      'Apothekersassistent',
      'Tandartsassistent',
      'Technisch oogheelkundig assistent',
      'Orthopedisch technisch specialist',
      'Tandtechnicus prothese',
      'Medisch pedicure'
    ],
    'Dieren & Paardensport': [
      'Dierenartsassistent paraveterinair',
      'Instructeur paardensport en -houderij'
    ]
  },
  'Techniek en Engineering': {
    'Elektrotechniek & Mechatronica': [
      'Technicus elektrotechniek',
      'Technicus data',
      'Technicus mechatronica',
      'Technicus elektrotechnische industriële systemen en installaties',
      'Technicus elektrotechnische installaties in de gebouwde omgeving',
      'Technicus service en onderhoud elektrotechniek en instrumentatie'
    ],
    'Werktuigbouw & Mechanica': [
      'Technicus service en onderhoud werktuigbouw',
      'Technicus service en onderhoud werktuigkundige installaties',
      'Technicus mechanica luchtvaartuigen',
      'Technicus industriële koude- en klimaatsystemen',
      'Onderhoudsmonteur',
      'Installatiemonteur',
      'Junior Technisch Tekenaar'
    ],
    'Voertuigen & Luchtvaart': [
      'Technicus avionica luchtvaartuigen',
      'Technisch specialist voertuigen en mobiele werktuigen',
      'Technisch specialist autoschadeherstel',
      'Technisch specialist verbrandingsmotoren'
    ],
    'Water & Gas': [
      'Technicus gas',
      'Technicus water'
    ],
    'Engineering & Ontwerp': [
      'Technicus engineering',
      'Technisch leidinggevende'
    ]
  },
  'Onderwijs en Coaching': {
    'Docenten & Begeleiders': [
      'Onderwijsassistent',
      'Praktijkopleider',
      'Vakdocent',
      'Pedagogisch Werker',
      'Trainer-coach/Instructeur',
      'Instructeur mbo'
    ],
    'Sport & Beweging': [
      'Buurtsportcoach',
      'Bewegingsagoog'
    ],
    'Duurzaamheid & Maatschappij': [
      'Coördinator duurzaamheid'
    ]
  },
  'Ondernemerschap en Bedrijfskunde': {
    'Management & Leiding': [
      'Manager mobiliteitsbranche',
      'Manager/bedrijfsleider fastservice',
      'Manager/ondernemer horeca',
      'Manager/bedrijfsleider bloem, groen en styling',
      'Bedrijfsleider dierverzorging',
      'Bedrijfsleider paardensport en -houderij',
      'Bedrijfsleider/ondernemer bloem, groen en styling',
      'Business administration & control specialist',
      'Commercieel Manager',
      'Projectleider Bedrijfskunde'
    ],
    'Commercieel & Verkoop': [
      'Junior accountmanager',
      'Retailmanager',
      'Junior manager groothandel',
      'Junior manager internationale handel',
      'E-commerce Specialist',
      'Interieuradviseur'
    ],
    'Zelfstandig Ondernemerschap': [
      'Vakspecialist ondernemer',
      'Ondernemer handel',
      'Ondernemer bakkerij',
      'Ondernemer vers',
      'Ondernemerhandel',
      'Meewerkend horeca ondernemer',
      'Ondernemend meubelmaker / (scheeps)interieurbouwer',
      'Zelfstandig Ondernemer'
    ]
  },
  'Media, Communicatie en Marketing': {
    'Media & Creatie': [
      'Mediamanager',
      'Mediaredactiemedewerker',
      'Mediavormgever'
    ],
    'Marketing & Communicatie': [
      'Marketing & communication specialist',
      'Communicatieadviseur',
      'Public Relations Specialist',
      'Content Manager',
      'E-commerce specialist'
    ]
  },
  'Creatieve en Technische Sectoren': {
    'Groen, Bloem & Styling': [
      'Vakexpert bloem, groen en styling',
      'Vakexpert groen, grond en groene infra'
    ],
    'Vormgeving & Ambacht': [
      'Ruimtelijk vormgever',
      'Signspecialist',
      'Decoratie- en restauratieschilder',
      'Zilversmid',
      'Goudsmid',
      'Creatief vakman'
    ],
    'Voeding & Technologie': [
      'Vakexpert voeding, kwaliteit en productontwikkeling',
      'Vakexpert voeding, technologie en techniek'
    ],
    'Geo & Design': [
      'Vakexpert geo, data & design'
    ],
    'Agrarisch & Agro': [
      'Vakexpert biologisch-dynamische landbouw',
      'Vakexpert teelt en groene technologie',
      'Vakexpert agrohandel en logistiek'
    ],
    'Mode & Styling': [
      'Allround make-up and hair artist',
      'Fashion tailor',
      'Fashion designer',
      'Fashion product coördinator',
      'Interieuradviseur'
    ]
  },
  'Technische Specialismen': {
    'Klimaat & Koudetechniek': [
      'Systeemontwerper koude- en klimaatsystemen'
    ],
    'Engineering & Techniek': [
      'Commercieel technicus engineering',
      'Software developer'
    ],
    'Voertuigentechniek': [
      'Technisch specialist autoschadeherstel',
      'Technisch specialist voertuigen en mobiele werktuigen',
      'Technisch specialist verbrandingsmotoren',
      'Technisch specialist elektrotechniek'
    ],
    'Tekenwerk & Voorbereiding': [
      'Tekenaar ontwerper elektrotechniek',
      'Tekenaar ontwerper werktuigkundige installaties',
      'Tekenaar constructeur',
      'Werkvoorbereider installaties',
      'Werkvoorbereider gespecialiseerde aannemerij',
      'Werkvoorbereider houttechniek',
      'Werkvoorbereider meubelindustrie / (scheeps)interieurbouw',
      'Werkvoorbereider fabricage'
    ]
  },
  'Bouw en Infra': {
    'Uitvoering & Coördinatie': [
      'Uitvoerder bouw/infra',
      'Uitvoerder',
      'Uitvoerder gespecialiseerde aannemerij',
      'Coördinator havenoperaties',
      'Coördinator duurzaamheid',
      'Opzichter/uitvoerder groene ruimte'
    ],
    'Restauratie & Afwerking': [
      'Decoratiestukadoor',
      'Specialist restauratie timmerwerk',
      'Specialist restauratie metselwerk',
      'Specialist restauratie schilderwerk'
    ],
    'Middenkader Bouw & Infra': [
      'Middenkaderfunctionaris verkeer en stedenbouw',
      'Middenkaderfunctionaris landmeetkunde',
      'Middenkaderfunctionaris grond-, weg- en waterbouw',
      'Middenkaderfunctionaris bouw',
      'Middenkaderfunctionaris smart building'
    ]
  },
  'Logistiek en Transport': {
    'Logistiek & Distributie': [
      'Logistiek supervisor',
      'Transport en logistiek',
      'Specialist internationale havenlogistiek'
    ],
    'Luchtvaart & Maritiem': [
      'Air cargo specialist',
      'Luchtvaartdienstverlener',
      'Aviation operations specialist',
      'Kapitein binnenvaart',
      'Maritiem officier alle schepen nautisch, visserij',
      'Maritiem officier alle schepen nautisch, waterbouw',
      'Maritiem officier alle schepen nautisch, koopvaardij'
    ]
  },
  'Mode en Styling': {
    'Modeontwerp & Productie': [
      'Fashion tailor',
      'Fashion product coördinator',
      'Fashion designer'
    ],
    'Podium & Evenement': [
      'Allround podium- en evenemententechnicus'
    ],
    'Kappers & Salons': [
      'Salonmanager dame',
      'Salonmanager heer'
    ]
  }
};

export default MBO_NIVEAU_4_STUDIES;